import { Constants } from '@leverege/molten-core';
import ImagineAttributeSortConverter from "./ImagineAttributeSortConverter.js";
import ImagineSortModelBlueprintProcessor from "./ImagineSortModelBlueprintProcessor.js";
export default {
  install(molten) {
    molten.addPlugin('ImagineAttributeSortConverter', ImagineAttributeSortConverter);
    molten.addPlugin(Constants.BLUEPRINTS_PROCESSOR, ImagineSortModelBlueprintProcessor);
  }
};